<template>
     <div class="wrapper">
    <span class="minus" @click="decrease()">-</span>
    <span class="num"><strong> {{getValue}}</strong></span>
    <span class="plus" @click="increase()">+</span>
  </div>
</template>
<script>
export default {
  props:['val'],
  data () {
    return {
      value : this.val
    }
  },
  computed:{
    getValue () {
      return this.value
    }
  },
  methods:{
    increase () {
      this.value += 1
      this.$emit('value', this.value)
    },
    decrease () {
      if (this.value > 0) {
        this.value -= 1
        this.$emit('value', this.value)
      }
    }
  }

}
</script>
<style>
.wrapper{
  height: 30px;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFF;
  border-radius: 12px;
  box-shadow: 0 5px 10px rgba(0,0,0,0.2);
}
.wrapper span{
  width: 100%;
  text-align: center;
  cursor: pointer;
  user-select: none;
}
.wrapper span.num{
  border-right: 2px solid rgba(0,0,0,0.2);
  border-left: 2px solid rgba(0,0,0,0.2);
  pointer-events: none;
}

.wrapper span.plus:hover{
  background-color: #f0b104;
  box-shadow: 0 5px 10px rgba(0,0,0,0.2);
  border-radius: 12px;
}
.wrapper span.minus:hover{
  background-color: #f0b104;
  box-shadow: 0 5px 10px rgba(0,0,0,0.2);
  border-radius: 12px;
}

</style>